<template>
  <div></div>
</template>

<script>
// 解决页面路由不刷新问题
// 跳转过来的格式  this.$router.replace({ path: `/redirect${this.$route.fullPath}` })
export default {
  name: "RedirectPage",
  created() {
    const { params, query } = this.$route;
    const { path } = params;
    this.$router.replace({ path: `/${path}`, query });
  },
  render(h) {
    return h();
  }
};
</script>

<style lang="scss" scoped>
</style>
